import { render } from "./NavigatorDock.vue?vue&type=template&id=52401c2a&scoped=true"
import script from "./NavigatorDock.vue?vue&type=script&lang=js"
export * from "./NavigatorDock.vue?vue&type=script&lang=js"

import "./NavigatorDock.vue?vue&type=style&index=0&id=52401c2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52401c2a"],['__file',"src/components/NavigatorDock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52401c2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52401c2a', __exports__)) {
    api.reload('52401c2a', __exports__)
  }
  
  module.hot.accept("./NavigatorDock.vue?vue&type=template&id=52401c2a&scoped=true", () => {
    api.rerender('52401c2a', render)
  })

}


export default __exports__